import {useLayoutEffect} from 'react';
import {overviewViewportBottom} from '../overview/overviewViewportBounds';

// Content-sized web wrappers must not become their own viewport boundary:
// doing so causes a resize feedback loop that shrinks the record list.
export function statisticsViewportBottom(root,desktop) {
  if(desktop)return overviewViewportBottom(root);
  let bottom=window.visualViewport?window.visualViewport.offsetTop+window.visualViewport.height:window.innerHeight;
  for(let parent=root.parentElement;parent&&parent!==document.body;parent=parent.parentElement){
    const style=getComputedStyle(parent);
    bottom-=(parseFloat(style.paddingBottom)||0)+(parseFloat(style.borderBottomWidth)||0);
  }
  return bottom;
}

// On roomy windows, both clients keep workspace controls fixed while each
// dashboard column owns its scrolling.
export default function useStatisticsWorkspaceViewport(ref,studio) {
  useLayoutEffect(()=>{
    const root=ref.current;
    if(!root)return undefined;
    const desktop=Boolean(window.desktopAPI||root.closest('.desktop-main'));
    root.dataset.statisticsClient=desktop?'desktop':'web';
    let frame=0;
    const measure=()=>{
      frame=0;
      const stickyTop=`${Math.max(12,Math.round(root.getBoundingClientRect().top+window.scrollY+12))}px`;
      if(root.style.getPropertyValue('--statistics-sticky-top')!==stickyTop)root.style.setProperty('--statistics-sticky-top',stickyTop);
      const records=!studio&&Boolean(root.querySelector('.ts-grid,.desktop-team-stats-grid'));
      const studioBounded=studio&&window.innerWidth>=1000&&window.innerHeight>=640&&Boolean(root.querySelector('.--TSD-dashboard-layout'))&&!root.querySelector('.--TSD-report-builder');
      const bounded=records||studioBounded;
      if(!bounded){delete root.dataset.studioBounded;delete root.dataset.recordsBounded;root.style.removeProperty('--statistics-workspace-height');return;}
      if(!root.dataset.studioBounded&&!root.dataset.recordsBounded){
        // Enter a new workspace at its header, including after a route change
        // from a page that had been scrolled down.
        for(let parent=root.parentElement;parent&&parent!==document.body;parent=parent.parentElement)if(parent.scrollTop)parent.scrollTop=0;
        if(window.scrollY)window.scrollTo(0,0);
      }
      if(records){root.dataset.recordsBounded='true';delete root.dataset.studioBounded;}
      else{root.dataset.studioBounded='true';delete root.dataset.recordsBounded;}
      const height=Math.max(240,Math.floor(statisticsViewportBottom(root,desktop)-Math.max(0,root.getBoundingClientRect().top)));
      const value=`${height}px`;
      if(root.style.getPropertyValue('--statistics-workspace-height')!==value)root.style.setProperty('--statistics-workspace-height',value);
    };
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(measure);};
    const resize=typeof ResizeObserver==='function'?new ResizeObserver(schedule):null;
    resize?.observe(root);
    for(let parent=root.parentElement;parent&&parent!==document.body;parent=parent.parentElement)resize?.observe(parent);
    const mutations=typeof MutationObserver==='function'?new MutationObserver(schedule):null;
    mutations?.observe(root,{childList:true,subtree:true});
    window.addEventListener('resize',schedule);window.visualViewport?.addEventListener('resize',schedule);measure();
    return()=>{if(frame)cancelAnimationFrame(frame);resize?.disconnect();mutations?.disconnect();window.removeEventListener('resize',schedule);window.visualViewport?.removeEventListener('resize',schedule);delete root.dataset.studioBounded;delete root.dataset.recordsBounded;root.style.removeProperty('--statistics-workspace-height');root.style.removeProperty('--statistics-sticky-top');};
  },[ref,studio]);
}
